export default __webpack_public_path__ + "static/media/circularUpArr.beb3c80f.svg";